import { render } from "./NewPost.vue?vue&type=template&id=2426f78e&scoped=true&lang=pug"
import script from "./NewPost.vue?vue&type=script&lang=js"
export * from "./NewPost.vue?vue&type=script&lang=js"

import "./NewPost.vue?vue&type=style&index=0&id=2426f78e&scoped=true&lang=sass"

import exportComponent from "/Users/adolforeyna/Projects/EMI/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2426f78e"]])

export default __exports__